import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=5abe1428&scoped=true&"
import script from "./ChatBubble.vue?vue&type=script&lang=js&"
export * from "./ChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=5abe1428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe1428",
  null
  
)

export default component.exports